<div class="container h-100">
  <div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="!isLoading">
    <div class="card RegularForm rounded col-12 col-lg-10">
      <div class="row m-4" *ngIf="
      memberSearchService.memberArr.length == 0
    ">
        <div class="col-12 text-center text-dark" [class.SmallArabicFont]="globalService.isRTL == true">
          <br>
          {{ globalService.Get("NODATA") }}
        </div>
      </div>
      <div class="card-body MyCardBody rounded-bottom" *ngIf="showOnMap == false && clusterOnMap == false">
        <div *ngIf="
            memberSearchService.memberArr != null &&
            memberSearchService.memberArr.length > 0
          " [class.text-right]="globalService.isRTL == true">
          <br />
          <div *ngFor="let user of memberSearchService.memberArr">
            <form #memberForm="ngForm" [class.SmallArabicFont]="globalService.isRTL == true">
              <input type="hidden" class="form-control" name="id" required #id="ngModel" [(ngModel)]="user.id" />
              <div class="row">
                <div class="input-group col-12" [class.mb-2]="user.expanded == null || user.expanded == false"
                  [class.mb-1]="user.expanded == true">
                  <button class="btn optionButton" [class.mr-1]="globalService.isRTL == false"
                    [class.ml-1]="globalService.isRTL == true" [class.btn-primary]="user.selected == true"
                    [class.btn-outline-secondary]="user.selected == false"
                    (click)="memberSearchService.ToggleSelection(user)" type="button">
                    <i class="fas fa-check-circle"></i>
                  </button>
                  <input type="text" class="form-control" name="fullName"
                    [class.bg-secondary]="user['expandFunctions'] == true"
                    [class.text-white]="user['expandFunctions'] == true" style="min-width: 50px" ngModel
                    [readonly]="true" #fullName="ngModel" [(ngModel)]="user.fullName" />
                  <button class="btn optionButton " [class.ml-1]="globalService.isRTL == false"
                    [class.mr-1]="globalService.isRTL == true"
                    [class.btn-outline-secondary]="(!user['expandFunctions']) || (user['expandFunctions'] == false)"
                    [class.btn-primary]="user['expandFunctions'] == true" (click)="ExpandFunctions(user)" type="button">
                    <i class="fas"
                      [class.fa-angle-up]="(!user['expandFunctions']) || (user['expandFunctions'] == false)"
                      [class.fa-angle-down]="user['expandFunctions'] == true"></i>
                  </button>
                </div>
              </div>
              <!-- <div *ngIf="user.expandFunctions"> -->
              <app-user-tools *ngIf="user['confirmView'] == false && user['editView'] == false" [user]="user"
                [subdomain]="subdomain" [showDefault]="true" (actionClicked)="confirmAction($event)">
              </app-user-tools>
              <app-user-task [user]="user" [plansArr]="plansArr" [applyRefresh]="true"></app-user-task>
              <!-- </div> -->
            </form>
          </div>
          <br />
          <div class="m-auto" [class.text-right]="globalService.isRTL == false"
            [class.text-left]="globalService.isRTL == true" *ngIf="
              memberSearchService.memberArr.length > 0 &&
              (identityService.hasLeader())
            ">
            <button class="btn btn-primary btn-block"
              [disabled]="memberSearchService.selectedMembers.length == 0 || memberSearchService.selectedMembers.length > 100"
              (click)="showOnMap = true;clusterOnMap = false">
              <span> Show On Map </span>
            </button>
          </div>
        </div>
      </div>
      <div class="text-dark" *ngIf="showOnMap == true">
        <app-members-on-map [contactsArr]="GetContacts()"></app-members-on-map>
      </div>
    </div>
  </div>
</div>